<nz-layout class="layout min-h-[50vh]">
  <nz-header class="bg-white">
    <franbase-header></franbase-header>
  </nz-header>
  <nz-content>
    <div class="inner-content pt-[61px] xl:pt-[79px] pb-1/2">
      <router-outlet></router-outlet>
    </div>
  </nz-content>
  <nz-footer>
    <franbase-footer></franbase-footer>
  </nz-footer>
</nz-layout>
